import { useMemo } from 'react'
import { AxiosError } from 'axios'
import { useQueries, UseQueryOptions, UseQueryResult } from 'react-query'
import {
  every,
  filter,
  flatMap,
  get,
  identity,
  orderBy,
  some,
  uniqBy,
  flow,
} from 'lodash/fp'

import { IGood } from '@monorepo/interfaces'
import { useApi } from '../useApi'

type RequestOptionsType = {
  strict?: boolean
  useFTS?: boolean
}

const QUERY_KEY = 'findGood'

const getFetching = some<boolean>(get('isFetching'))
const getFetched = every<boolean>(get('isFetched'))

const getData = flow(
  flatMap<UseQueryResult<IGood>, IGood>((res) => res.data ?? []),
  filter(Boolean),
  uniqBy('id'),
  orderBy(['suggestionRating', 'brand.name'], ['desc', 'asc'])
)

export function useSuggestions<TData = IGood[]>(
  number: string,
  {
    strict = false,
    useFTS = false,
    select = identity,
    ...options
  }: UseQueryOptions<IGood[], AxiosError, TData> & RequestOptionsType = {}
) {
  // const fetcher = useCallback(() => api.search.fetchGoods(number, strict), [
  //   number,
  //   strict,
  // ])
  const { fetchSuggestions } = useApi()

  const queries = [{} /*, { vendor: 6 }*/].map<
    UseQueryOptions<IGood[], AxiosError, TData>
  >((filter) => ({
    queryKey: [QUERY_KEY, { number, strict, useFTS, ...filter }],
    queryFn: () => fetchSuggestions(number, { strict, useFTS, ...filter }),
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
    ...options,
  }))

  const results = useQueries(queries as UseQueryOptions[]) as UseQueryResult<
    TData,
    AxiosError
  >[]

  return useMemo(() => {
    const data = select(getData(results))

    const isFetchingStarted = results.length > 0
    const isFetching = !isFetchingStarted || getFetching(results)
    const isFetched = isFetchingStarted && getFetched(results)

    return { data, isFetching, isFetched }
  }, [results, select])

  // return useQuery(['findGood', number, strict], fetcher, {
  //   refetchOnWindowFocus: false,
  //   staleTime: 60 * 1000,
  //   ...options,
  // })
}
